/**
 * Mainbeauty — lọc bài viết trang Kiến thức không tải lại trang.
 */
function zoneEl() {
  return document.querySelector("[data-pi-posts]");
}

function currentFilter() {
  const params = new URLSearchParams(window.location.search);
  const match = window.location.pathname.match(/\/page\/(\d+)\/?/);
  return {
    cat: params.get("chuyen-muc") || "",
    paged: match ? parseInt(match[1], 10) : 1,
  };
}

function buildUrl(zone, cat, paged) {
  const base = (zone.getAttribute("data-pi-url") || window.location.pathname).replace(/\/$/, "");
  let url = base + (paged > 1 ? "/page/" + paged + "/" : "/");
  if (cat) url += "?chuyen-muc=" + encodeURIComponent(cat);
  return url;
}

function markActivePill(cat) {
  document.querySelectorAll(".pi-cats .cat").forEach((pill) => {
    pill.classList.toggle("on", (pill.getAttribute("data-pi-cat") || "") === cat);
  });
}

function load(cat, paged, push) {
  const zone = zoneEl();
  if (!zone) return;

  zone.setAttribute("aria-busy", "true");
  zone.classList.add("is-loading");

  const body = new URLSearchParams();
  body.set("action", "pi_filter_posts");
  body.set("cat", cat);
  body.set("paged", paged);

  fetch(zone.getAttribute("data-pi-ajax"), {
    method: "POST",
    credentials: "same-origin",
    body: body,
  })
    .then((res) => res.json())
    .then((json) => {
      if (!json || !json.success) throw new Error("bad response");
      zone.innerHTML = json.data.html;
      markActivePill(cat);
      if (push) window.history.pushState({ cat, paged }, "", buildUrl(zone, cat, paged));

      // Danh sách nằm dưới hero — cuộn về đầu khối cho khỏi lạc chỗ.
      const section = document.getElementById("dsbai");
      if (section) {
        const top = section.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: "smooth" });
      }
    })
    .catch(() => {
      // Hỏng đường truyền → quay lại điều hướng thường, không kẹt người dùng.
      window.location.href = buildUrl(zone, cat, paged);
    })
    .finally(() => {
      zone.setAttribute("aria-busy", "false");
      zone.classList.remove("is-loading");
    });
}

document.addEventListener("click", (e) => {
  if (!zoneEl()) return;

  const pill = e.target.closest(".pi-cats .cat");
  if (pill) {
    e.preventDefault();
    load(pill.getAttribute("data-pi-cat") || "", 1, true);
    return;
  }

  const pager = e.target.closest(".pi-pager a.page-numbers");
  if (pager) {
    e.preventDefault();
    const url = new URL(pager.href, window.location.origin);
    const match = url.pathname.match(/\/page\/(\d+)\/?/);
    const paged = match ? parseInt(match[1], 10) : 1;
    load(currentFilter().cat, paged, true);
  }
});

window.addEventListener("popstate", () => {
  if (!zoneEl()) return;
  const state = currentFilter();
  load(state.cat, state.paged, false);
});
